
import * as React from "react";
import { ColorizerState, ConfiguredArea } from "./colorizer-state";
import { SidingType, SidingColor, hexCodeFor, typeNameMap, colorNameMap, imageUrlForColor } from "./colors";

interface SelectionsListProps extends React.Props<SelectionsListProps> {
	config: ColorizerState;
}

export class SelectionsList extends React.Component<SelectionsListProps, {}> {
	render() {

		return (
			<div className="selections-list">
				<h1>Your Selections:</h1>
				<SelectionRow config={ this.props.config.Trim }/>
				<SelectionRow config={ this.props.config.AreaB }/>
				<SelectionRow config={ this.props.config.AreaC }/>
				<SelectionRow config={ this.props.config.AreaA }/>
			</div>
		)
	}
}

interface SelectionRowProps extends React.Props<SelectionRowProps> {
	config: ConfiguredArea;
}

class SelectionRow extends React.Component<SelectionRowProps, {}> {

	titleFor(type: SidingType):string {
		if(type === SidingType.Trim) {
			return "Soffit and Fascia";
		}
		return "Siding Choice: " + typeNameMap(type);
	}

	render() {
		return (<div className="selection">
			<span>{this.titleFor(this.props.config.SidingType)}</span>
			<div className="swatch" title={colorNameMap(this.props.config.SelectedColor)}>
				<img src={imageUrlForColor(this.props.config.SelectedColor, 40, 40)} />
			</div>
			<div>
				{colorNameMap(this.props.config.SelectedColor)}
			</div>
		</div>);
	}
}